<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import OrderCreateDaterange from '~/components/account/filters/OrderCreateDaterange.vue'

    @Component({mixins: [OrderCreateDaterange]})
    export class OrderServiceDaterange extends Vue {
        get maxStartDate() {
            return undefined
        }

        get maxEndDate() {
            return undefined
        }
    }

    export default {...toNative(OrderServiceDaterange), ssrRender: OrderCreateDaterange.ssrRender}
</script>
